import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const ClientAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/Client/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/Client/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

ClientAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default ClientAutocomplete;
